<!-- 课程 -->
<template>
    <el-dialog v-dialogDrag :title="title" :visible.sync="dialogVisible" width="1000px" top="200px"
        :modal-append-to-body="false">

        <!-- v-if  从新渲染 -->
        <div class="content">
            <div class="c_l">
                <p>
                    <span class="label">
                        岗位名称：
                    </span>
                    <span class="value">
                        {{ ruleForm.position_name }}
                    </span>
                </p>
                <p>
                    <span class="label">
                        岗位类型：
                    </span>
                    <span class="value">
                        {{ ruleForm.position_type ? ruleForm.position_type.join(' . ') : '' }}
                    </span>
                </p>
                <p>
                    <span class="label">
                        岗位有效范围：
                    </span>
                    <span class="value">
                        {{ ruleForm.position_effective_start }}
                        -
                        {{ ruleForm.position_effective_end }}
                    </span>
                </p>
                <p>
                    <span class="label">
                        岗位企业名称：
                    </span>
                    <span class="value">
                        {{ ruleForm.position_enterprise_name }}
                    </span>
                </p>
                <p>
                    <span class="label">
                        企业标签：
                    </span>
                    <span class="value">
                        <el-tag v-for="(item, index) in ruleForm.enterprise_tags.map(item => item.tags_value)"
                            :key="index">{{ item }}
                        </el-tag>

                    </span>
                </p>
                <p>
                    <span class="label">
                        申请时间：
                    </span>
                    <span class="value">
                        <span>{{ ruleForm.ctime_str }}</span>
                    </span>
                </p>
            </div>
            <div class="c_r">
                <p>
                    <span class="label">
                        当前状态：
                    </span>
                    <span class="value">
                        <span >{{ ruleForm.bidding_state }}</span>
                    </span>
                </p>
                <p>
                    <span class="label">
                        最高竞价价格：
                    </span>
                    <span class="value color_red">
                        {{ ruleForm.max_bidding_price }}
                        <span>
                            (￥)
                        </span>
                    </span>

                </p>
                <p>
                    <span class="label">
                        最高竞价企业名称：
                    </span>
                    <span class="value">
                        {{ ruleForm.max_bidding_enterprise_name }}
                    </span>
                </p>
                <p>
                    <span class="label">
                        我的报价：
                    </span>
                    <span class="value color_red">
                        {{ ruleForm.quoted_price }}
                        <span>
                            (￥)
                        </span>
                    </span>

                </p>
                <p>
                    <span class="label">
                        企业名称：
                    </span>
                    <span class="value">
                        {{ enterprise_name }}
                    </span>
                </p>

            </div>
        </div>
    </el-dialog>
</template>

<script>
export default {
    props: {

    },
    data() {
        return {
            dialogVisible: false,
            title: '竞价详情',
            options2: [],
            enterpriseOptions: JSON.parse(localStorage.getItem('entinfolist')),
            "enterprise_id": localStorage.getItem('enterprise_id'),//企业唯一标识
            enterprise_name: '',
            ruleForm: {
                "bidding_state":"",
                "ctime_str": "",
                "recruitment_id": "",
                "position_name": "",
                "position_type": [

                ],
                "position_enterprise_id": "",
                "position_enterprise_name": "",
                "position_effective_start": "",
                "position_effective_end": "",
                "position_bidding_start": "",
                "position_bidding_end": "",
                "position_bidding_state": "2",
                "enterprise_tags": [

                ],
                "max_bidding_enterprise_id": "",
                "max_bidding_enterprise_name": "",
                "max_bidding_price": '',
                "quoted_price": ''
            },
            postForm: {
                'enterprise_id': localStorage.getItem('enterprise_id'),
                'enterprise_name': '',
                biddings: []
            },

            rules: {
                outline_name: [
                    { required: true, message: '请输入课程名称', trigger: 'blur' },

                ],
                enterprise_id: [
                    { required: true, message: '请选择所属企业', trigger: 'change' }
                ],
            }
        }
    },
    created() {

    },
    methods: {
        // 获取数据字典值
        async getDictsData(dict, optionsNmae) {
            let options = [];
            await this.$tools
                .asyncPost(this, this.$baseUrl.dictinfogetbycode, {
                    data: {
                        dictionary_code: dict,
                    },
                })
                .then((res) => {
                    if (res.data.code == 0) {
                        options = res.data.data.dictionary_detail;
                    } else {
                        // this.$message({ type: "error", message: res.data.msg });
                    }
                })
                .catch((err) => {
                    // this.$message({ type: "error", message: err });
                });
            this[optionsNmae] = options;
        },
        init(data) {
            this.ruleForm = data
            this.ruleForm.position_type=this.ruleForm.position_type?this.ruleForm.position_type:[]
            this.ruleForm.enterprise_tags=this.ruleForm.enterprise_tags?this.ruleForm.enterprise_tags:[]
            this.getDictsData('HR-KJ-KC-JJSQ-JSZT', 'options2')
            let obj = this.recursion(this.enterpriseOptions)
            this.enterprise_name = obj.enterprise_name
        },
        handleClose(done) {

            done();

        },
        handleOk() {
            this.$refs['ruleForm'].validate((valid) => {
                if (valid) {
                    this.postForm.biddings.forEach(item => {
                        item.quoted_price = Number(item.quoted_price) + Number(this.ruleForm.quoted_price)
                    })



                    this.$tools
                        .asyncPost(
                            this,
                            this.$baseUrl.biddingApplicationBatchAdd, {
                            data: this.postForm
                        }).then((res) => {
                            if (res.data.code == 0) {
                                this.$message({ type: "success", message: '添加成功' });
                                this.$emit('ok')
                                this.dialogVisible = false


                            } else {
                                this.$message({ type: "error", message: res.data.msg });
                            }
                        }).catch((err) => {
                            // this.loading = false; 
                        });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        recursion(arr) {
            let obj;
            for (let i = 0; i < arr.length; i++) {
                if (arr[i].options) {
                    obj = this.recursion(arr[i].options)
                    if (obj) {
                        return obj
                    }
                }
                if (arr[i].enterprise_id && arr[i].enterprise_id == this.enterprise_id) {
                    // obj = arr[i]

                    return arr[i];
                }
            }

        },
        handleChange(value) {
            console.log(value);
            let obj = this.recursion(this.options)

            this.ruleForm.enterprise_name = obj.enterprise_name
        },

        getOptions() {


            this.$tools
                .asyncPost(
                    this,
                    this.$baseUrl.trainingOutlineTree, {
                    data: this.postForm3
                }).then((res) => {
                    if (res.data.code == 0) {
                        res.data.data.forEach(item => {
                            item.fold = true
                        })
                        this.options = res.data.data


                    } else {
                        this.$message({ type: "error", message: res.data.msg });
                    }
                    this.loading = false;
                }).catch((err) => { this.loading = false; });
        },
    }
}
</script>

<style lang="less" scoped>
.content {
    display: flex;
    padding: 20px 20px;

    .c_l,
    .c_r {
        width: 50%;

        p {
            display: flex;
            align-items: center;
            margin-bottom: 20px;

            .label {
                width: 150px;
                text-align: right;
                margin-right: 10px;
            }

            .value {
                flex: 1;
            }
        }
    }

    .c_r {}
}
</style>
